import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { MessageSpark } from "shared/types/notify";
import {
  SparkNotificationStatus,
  SparksNotificationProfileT,
  SparksStateT,
} from "shared/types/sparks";

export const initialState: SparksStateT = {
  items: [],
  hasUnviewed: false,
  uploaded: false,
  send: false,
  error: false,
};

const sparksListSlice = createSlice({
  name: "sparks",
  initialState,
  reducers: {
    clearFeed: () => {
      return {
        ...initialState,
      };
    },
    setSparksList: (
      state,
      { payload }: PayloadAction<SparksNotificationProfileT[]>
    ) => {
      return {
        ...state,
        items: payload,
        uploaded: true,
        send: false,
      };
    },
    setNotificationActivityStatus: (
      state,
      { payload }: PayloadAction<boolean>
    ) => {
      state.hasUnviewed = payload;
    },
    addNewSpark: (state, { payload }: PayloadAction<MessageSpark>) => {
      const spark = {
        uid: payload.uid,
        status: SparkNotificationStatus.NotViewed,
        updatedAt: payload.created_at,
        profile: {
          avatar: payload?.avatar,
          uid: payload?.user_id,
          username: payload?.first_name,
        },
      };

      state.items = [spark as SparksNotificationProfileT, ...state.items];
      state.hasUnviewed = true;
    },
    markAsViewed: (state, { payload }: PayloadAction<number>) => {
      for (const [index, item] of state.items.entries()) {
        if (item.profile.uid === payload) {
          state.items[index].status = SparkNotificationStatus.Viewed;
          break;
        }
      }

      state.hasUnviewed = state.items?.some(
        (item) => item.status === SparkNotificationStatus.NotViewed
      );
    },
    toggleSend: (state, { payload }: PayloadAction<boolean>) => {
      state.send = payload;
    },
    responseErrorFeed: (state) => {
      return {
        ...state,
        send: false,
        error: true,
      };
    },
  },
});

export const {
  clearFeed,
  setSparksList,
  setNotificationActivityStatus,
  markAsViewed,
  addNewSpark,
  toggleSend,
  responseErrorFeed,
} = sparksListSlice.actions;

export default sparksListSlice.reducer;
